import { useCallback } from 'react'

import { GTM } from '../../../../../../helpers'
import nrLogger from '../../../../../../helpers/nrLogger'

const useExecuteGTM = ({
  index,
  pageType,
  data,
  selectedVehicle,
  invObj,
  groundDeliveryTime,
  widgetName = '',
  executeEcomATCEvent
}) => {
  const {
    addToCart: addToCartGTM,
    getProductFromDetails,
    blueshiftAddToCart,
    ecomAddToCartProductsGTM
  } = GTM

  return useCallback(
    () => {
      try {
        addToCartGTM({
          productList: pageType === 'mntsrp' ? 'Maintenance Recommendations' : 'Product Listing',
          productListPosition: index + 1,
          products: [
            getProductFromDetails(
              {
                ...data,
                vehicle: selectedVehicle,
                inventory: invObj,
                groundDeliveryTime,
              },
              1,
            ),
          ],
        })

        if (executeEcomATCEvent) {
          ecomAddToCartProductsGTM({
            quantity: 1,
            widgetName,
            product: data,
            inventory: invObj,
            groundDeliveryTime,
            selectedVehicle,
          })
        }

        blueshiftAddToCart({
          email: null,
          product: {
            ...data,
            vehicle: selectedVehicle,
          },
          quantity: 1,
        })
      } catch (error) {
        console.error('error in useExecuteGTM', error?.message || error)
        nrLogger.error('ShoppingCartV2.AddButtonForPL.useAddToCartPL.useExecuteGTM.error', error)
      }
    },
    [
      index,
      pageType,
      data,
      selectedVehicle,
      invObj,
      groundDeliveryTime,
      addToCartGTM,
      getProductFromDetails,
      blueshiftAddToCart,
      ecomAddToCartProductsGTM
    ],
  )
}

export default useExecuteGTM
